<template>
    <!--滑动banner -->
    <div class="swiperbanner_container">
      <div class="ub ub-ac tips" v-if="is_setGift">
        <span>对方设置了解锁礼物，需要赠送对应的礼物</span>
      </div>
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide>
          <li class="ub ub-ver main-block" v-for="(item, index) in gift_1" :key="index">
            <div class="ub gift-block">
              <li class="ub ub-pc ub-ver gift-item ub-f1" v-for="sub_item in item" :key="sub_item.id" @click="chosedGift(sub_item)" :class="chosed == sub_item.coin ? 'on' : ''">
                <div>
                  <img :src="sub_item.url" class="gift-picture" />
                </div>
  
                <div class="gift-name">{{sub_item.name}}</div>
                <div class="gift-coin">{{sub_item.coin}}金币</div>
              </li>
            </div>
          </li>
        </swiper-slide>
  
        <swiper-slide>
          <li class="ub ub-ver main-block" v-for="(item, index) in gift_2" :key="index">
            <div class="ub gift-block">
              <li class="ub ub-pc ub-ver gift-item ub-f1" v-for="sub_item in item" :key="sub_item.id" @click="chosedGift(sub_item)" :class="chosed == sub_item.coin ? 'on' : ''">
                <div>
                  <img :src="sub_item.url" class="gift-picture" />
                </div>
  
                <div class="gift-name">{{sub_item.name}}</div>
                <div class="gift-coin">{{sub_item.coin}}金币</div>
              </li>
            </div>
          </li>
        </swiper-slide>
  
        <div class="swiper-pagination" slot="scrollbar"></div>
      </swiper>

      <div class=" gift-receiver ub ub-pc ub-ac2">
        <div class="ub ub-pc">
            <img :src="uinfo_to.photo" class="gift-photo" />
            <span class="gift-lable1">送给</span>
            <span class="gift-lable1">{{uinfo_to.nick.length > 6 ? uinfo_to.nick.substr(0,5) + '...' : uinfo_to.nick}}</span>
        </div>
        <div class="btn"  @click="send_gift(chosed_gift)">
            <span>赠送</span>
        </div>
      </div>
  
      <alert ref="myConfirm" @userBehavior="userBehaviorFun"></alert>
    </div>
  </template>
  
  <script>
  import * as tool from "../api/common";
  import { mapMutations, mapActions } from "vuex";
  import Alert from "../components/Alert.vue";
  export default {
    name: "Swiper_Gift",
    components: {
      alert: Alert,
    },
    props: {
      toUid: String,
      album_gift: String
    },
    data() {
      return {
        gift_1: [],
        gift_2: [],
  
        uinfo_to: {
          uid: "",
          photo: "",
          nick: "",
          sex: "",
          age_range: "",
          loc_province: "",
        },
  
        coin_left: 0,
  
        swiperOption: {
          direction: "horizontal",
  
          observeParents: true, //观察父组件，当父组件变化时，自己随着变化
          observer: true, //观察自己，自己的参数变化时，更新
          centeredSlides: true, //设置为true时，活动块居中显示，默认下居左显示
          loop: false, //滑动过程中会在前后复制多个slider,效果看起来是循环的
          loopedSlides: 3, //设置滑动过程中所要用到的loop个数
          slidesPerView: "auto", //同时显示的slide数量
          loopAdditionalSlides: 100,
          autoPlay: {
            delay: 3000,
            disableOnInteraction: false, //鼠标移动上去时是否继续播放
          },
          pagination: { el: ".swiper-pagination" },
          paginationType: "bullets",
          paginationElement: "span",
        },
  
        pre_send_time: new Date(),
        chosed: 0,
        chosed_gift: {
          id: 0,
          coin: 0,
          name: "",
          url: "",
        },
        is_setGift: false
      };
    },
    mounted() {
      this.init_page();
    },
    methods: {
      ...mapMutations(["get", "post", "delete", "put"]), //引入方法
      ...mapActions(["act_get_userinfo", "act_reload_userinfo", "act_sub_coin"]), //引入方法

      init_page() {
        var const_data = this.$store.state.const_data;
        this.gift_1 = tool.slice_arry(const_data.gift_1, 4);
        this.gift_2 = tool.slice_arry(const_data.gift_2, 4);

        var album_gift = this.album_gift;
        album_gift = Number(album_gift);
        if (album_gift > 0) {
          this.is_setGift = true;
          
          var chosed_gift = const_data.gift_2.filter(item => item.coin === album_gift);
          if (chosed_gift.length <= 0) {
            chosed_gift = const_data.gift_1.filter(item => item.coin === album_gift);
          }
          if (chosed_gift.length > 0) {
            this.chosed_gift = chosed_gift[0];
            this.chosed = album_gift;
          }
          

          if (album_gift >= 10000) {
            this.$refs.mySwiper.swiper.slideTo(1);
          }
        }


  
        var touid = this.toUid;
        var self = this;
        self.act_get_userinfo({
          uid: touid,
          success: function (u) {
            self.uinfo_to.uid = u.uid;
            self.uinfo_to.photo = u.photo;
            self.uinfo_to.nick = u.nick;
            self.uinfo_to.sex = u.sex;
            self.uinfo_to.age_range = u.age_range;
            self.uinfo_to.loc_province = u.loc_province;
          },
        });
  
        var uid = self.$store.state.uid;
        self.act_get_userinfo({
          uid: uid,
          success: function (u) {
            self.coin_left = u.coin_left;
          },
        });
  
      },
  
      sendGift(item) {
        var gif_url = item.url;
        var msg = { msg_type: "gift", msg_txt: gif_url };
        this.send(msg);
        this.$toast.center("礼物已送出，对方已收到~");
        this.$emit("gift_hidden",item);
      },

      send: function (msg) {
      //发送消息
      var send_msg = { to: this.toUid, type: msg.msg_type, txt: msg.msg_txt };
      this.$socket.emit("send_one", send_msg);
      
      //整理消息，本地store中保存
      send_msg.dtm = new Date().Format("yyyy/MM/dd hh:mm:ss");
      this.$store.commit("push_message", send_msg);
      this.$store.commit("set_msg_count");
      
      //发送微信通知
      this.wxSendMsg(send_msg);
    },

    wxSendMsg(msg){
    //  console.log("gift:"+JSON.stringify(msg));
      //获取微信模板消息相关参数
      var uid = msg.to;
      var tag = "12";

        var gift_item = {};
        var url = msg.txt;
        var const_data = this.$store.state.const_data;
        var arr = const_data.gift_1.concat(const_data.gift_2);
        var idx = tool.hasKey(arr, url, 'url');
        if (idx >= 0) {
            gift_item = arr[idx];
        }
        else {
            gift_item = arr[0];
        }

        //console.log(JSON.stringify(gift_item));


      var data = {
        "gift_name":gift_item.name,
        "tradeDateTime":msg.dtm,
        "tradeType":"收到礼物",
        "curAmount":gift_item.score + "积分"
      };

      var strData =  JSON.stringify(data)
      //console.log(strData);

      var self = this;
      this.post({
        url: "/Common/WxSendMsg2",
        data: { uid: uid, tag:tag, data: strData },
        success: function (serve_data) {
          console.log(JSON.stringify(serve_data));
        },
      });
    },
  
      userBehaviorFun(type, data) {
        if (type == "clickConfirm") {
          //保存state中的to_uid,解决返回相册页面to_uid为空情况
          if(!this.$store.state.to_uid ) {
            this.$store.commit("set_to_uid", this.toUid);
          }
          this.$router.push({ name: "mycoin" });
        }
      },

      chosedGift(item) {
        if (!this.is_setGift) {
          this.chosed_gift = item;
          this.chosed = item.coin;
        }
      },

      check_sendRate() {
        var bRtn = true;
  
        var pre_send_time = this.pre_send_time;
        var dtm_now = new Date();
        var sp = dtm_now.getTime() - pre_send_time.getTime();
  
        if (sp < 300) {
          this.$toast.center("发送频率过高哦");
          bRtn = false;
          return bRtn;
        }
        this.pre_send_time = dtm_now;
  
        return bRtn;
      },

      send_gift(item) {
        if (item.name !== "") {
          //发送频率检查
        if (!this.check_sendRate()) {
          var bRtn = false;
          return bRtn;
        }
  
        //判断金币是否够支付
        var self = this;
        var uid = self.$store.state.uid;
        self.act_get_userinfo({
          uid: uid,
          success: function (u) {
            if (u.coin_left >= item.coin) {
              //增加后台验证,重新加载用户数据即可
              var send_data = {
                uid_from: uid,
                uid_to: self.uinfo_to.uid,
                amount: item.coin,
                score: item.score,
                type_dtl: "发送礼物",
                comment: item.name,
              };
              self.act_sub_coin({
                uid: uid,
                strSend: JSON.stringify(send_data),
                success: function (res) {
                  if (res.state == "1") {
                    //扣金币成功
                    self.coin_left -= item.coin;
  
                    //可以发送，发送、并进行金币扣除
                    self.sendGift(item);
                  } else {
                    //金币不足提示
                    self.$refs.myConfirm.show("金币余额不足,请先充值哦", {
                      type: "confirm",
                      confirmText: "充值",
                      titleText: "温馨提示",
                      data: "",
                    });
                    return false;
                  }
                },
              });
            } else {
              //金币不足提示
              self.$refs.myConfirm.show("金币余额不足,请先充值哦", {
                type: "confirm",
                confirmText: "充值",
                titleText: "温馨提示",
                data: "",
              });
              return false;
            }
          },
        });
        } else {
          this.$toast.bottom("请先选择礼物~")
        }
        
        // console.log(JSON.stringify(item));
        
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>

  .swiperbanner_container {
    padding-top: 1rem;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: #333;
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
    .swiper-pagination {
      bottom: 2px !important;
    }
  }
  
  .tips {
    margin-bottom: 0.8rem;
    span {
      font-size: 0.9rem;
      color: #fff;
    }
  }
  
  .main-block {
    background-color: #333;
    .gift-block {
      padding: 0.2rem 0;
      justify-content: space-around;
      .on {
        border: 1px solid #8A61FF;
        border-radius: 0.5rem;
      }
      .gift-item {
        width: 4rem;
        margin: 0 1rem;
        .gift-picture {
          height: 3.5rem;
          width: 3rem;
          padding: 0.1rem;
        }
        
        .gift-name {
          margin-top: 0.2rem;
          font-size: 0.8rem;
          color: #fff;
        }
        
        .gift-coin {
          font-size: 0.6rem;
          color: #959595;
          margin-top: 0.2rem;
        }
      }
    }
  }
  
  .gift-receiver {
    padding: 0.5rem 1.5rem;
    background-color: #333;
    .gift-photo {
      height: 1.5rem;
      width: 1.5rem;
      border-radius: 50%;
    }
    .gift-lable1 {
      font-size: 0.75rem;
      color: #fff;
      margin-left: 0.5rem;
    }
    .btn {
        padding: 0.3rem 1rem;
        background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
        border-radius: 1rem;
        span {
            font-size: 0.9rem;
            font-weight: bold;
            color: #fff;
        }
    }
  }
  
  </style>